import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { PlusIcon } from '@heroicons/react/24/outline'

interface TeamCreationFormProps {
  onAddTeam: (teamName: string, description: string) => void
}

export function TeamCreationForm({ onAddTeam }: TeamCreationFormProps) {
  const [newTeamName, setNewTeamName] = useState('')
  const [newTeamDescription, setNewTeamDescription] = useState<string>('')

  const handleAddTeam = () => {
    if (newTeamName.trim()) {
      onAddTeam(newTeamName.trim(), newTeamDescription.trim())
      setNewTeamName('')
      setNewTeamDescription('')
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleAddTeam()
    }
  }

  return (
    <div className='px-6 py-3 border-b flex-shrink-0 bg-gray-50'>
      <div className='flex flex-col sm:flex-row gap-3'>
        <div className='flex-1 space-y-2'>
          <Input
            placeholder='Enter team name'
            value={newTeamName}
            onChange={(e) => setNewTeamName(e.target.value)}
            onKeyDown={handleKeyDown}
            className='bg-white'
          />
          <Input
            placeholder='Enter team description'
            value={newTeamDescription}
            onChange={(e) => setNewTeamDescription(e.target.value)}
            className='bg-white'
          />
        </div>
        <Button
          onClick={handleAddTeam}
          disabled={!newTeamName.trim()}
          className='bg-dark-blue hover:bg-dark-blue-hovered whitespace-nowrap disabled:opacity-50'
        >
          <PlusIcon className='w-4 h-4 mr-2' />
          <span className='hidden sm:inline'>Add Team</span>
          <span className='sm:hidden'>Add</span>
        </Button>
      </div>
    </div>
  )
}
